export default __webpack_public_path__ + "static/media/imageErrorIdCard.f5d11a69.svg";